import { CheckCircle, Lock } from "@mui/icons-material";
import { isUploadAllowed } from "./constants";

const StatusPill = ({ collectionStatus }) => {
  if (!collectionStatus) return null;
  const allowed = isUploadAllowed(collectionStatus);
  const statusText =
    typeof collectionStatus === "object"
      ? collectionStatus?.status || ""
      : collectionStatus;
  return (
    <span className={`cbc-pill ${allowed ? "green" : "red"}`}>
      {allowed ? <CheckCircle sx={{ fontSize: 12 }} /> : <Lock sx={{ fontSize: 12 }} />}
      {statusText}
    </span>
  );
};

export default StatusPill;
